// // App.js
// import React from 'react';
// import './App.css';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import HomePage from './Components/Home/HomePage';
// import TopNavbar from './Components/Navbar/TopNavbar';
// import SecondNav from './Components/Navbar/SecondNav';
// import About from './Components/Home/About';
// import Services from './Components/Home/Services';
// import Gallery from './Components/Home/Gallery';
// import Locations from './Components/Home/Locations';
// import Booking from './Components/Home/Booking';
// import Contact from './Components/Home/Contact';
// import Packages from './Components/Home/Packages';
// import FAQ from './Components/Home/FAQ';
// import Signup from './Components/Login.js/Signup';
// import OurProducts from './Components/Home/OurProducts';
// import Warranty from './Components/Home/Warranty';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/" element={<TopNavbar />} />
//         <Route path="/" element={<SecondNav />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/gallery" element={<Gallery />} />
//         <Route path="/locations" element={<Locations />} />
//         <Route path="/booking" element={<Booking />} />
//         <Route path="/packages" element={< Packages/>} />
//         <Route path="/products" element={<OurProducts />} />
//         <Route path="/warranty" element={<Warranty/>} />
//         <Route path="/faq" element={<FAQ />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/signup" element={<Signup />} />
//       </Routes>
      
//     </Router>
    
//   );
// }

// export default App;




// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import HomePage from './Components/Home/HomePage';
// import TopNavbar from './Components/Navbar/TopNavbar';
// import SecondNav from './Components/Navbar/SecondNav';
// import About from './Components/Home/About';
// import Services from './Components/Home/Services';
// import Gallery from './Components/Home/Gallery';
// import Locations from './Components/Home/Locations';
// import Booking from './Components/Home/Booking';
// import Contact from './Components/Home/Contact';
// import Packages from './Components/Home/Packages';
// import FAQ from './Components/Home/FAQ';
// import LoginForm from './Components/Login/LoginForm';
// import Dashboard from './Components/Dashboard/AUDashboard';
// import OurProducts from './Components/Home/OurProducts';
// import Warranty from './Components/Home/Warranty';


// // Child component to handle routing logic
// const AppContent = ({ showLogin, setShowLogin }) => {
//   const location = useLocation(); // Now useLocation works because AppContent is inside Router
//   const handleSignupSuccess = () => {
//     setShowLogin(true);
//   };

//   // Check if the current route is a dashboard route
//   const isDashboardRoute = location.pathname.startsWith('/dashboard');

//   return (
//     <>
//       {/* Conditionally render TopNavbar and SecondNav only for non-dashboard routes */}
//       {!isDashboardRoute && <TopNavbar />}
//       {!isDashboardRoute && <SecondNav />}
//       <Routes>
//         <Route path="/" element={<HomePage />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/gallery" element={<Gallery />} />
//         <Route path="/locations" element={<Locations />} />
//         <Route path="/booking" element={<Booking />} />
//         <Route path="/packages" element={<Packages />} />
//         <Route path="/faq" element={<FAQ />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/products" element={<OurProducts />} />
//         <Route path="/warranty" element={<Warranty/>} />
//         <Route path="/signup" element={<LoginForm onSignupSuccess={handleSignupSuccess} />} />
//         <Route path="/login" element={<LoginForm />} />
//         <Route path="/dashboard/*" element={<Dashboard />} />
//         <Route path="*" element={<Navigate to={showLogin ? "/login" : "/signup"} replace />} />
//       </Routes>
//     </>
//   );
// };

// const App = () => {
//   const [showLogin, setShowLogin] = useState(false);

//   return (
//     <Router>
//       <AppContent showLogin={showLogin} setShowLogin={setShowLogin} />
//     </Router>
//   );
// };

// export default App;
















import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './Components/Home/HomePage';
import TopNavbar from './Components/Navbar/TopNavbar';
import SecondNav from './Components/Navbar/SecondNav';
import About from './Components/Home/About';
import Services from './Components/Home/Services';
import Gallery from './Components/Home/Gallery';
import Locations from './Components/Home/Locations';
import Booking from './Components/Home/Booking';
import Contact from './Components/Home/Contact';
import Packages from './Components/Home/Packages';
import FAQ from './Components/Home/FAQ';
import LoginForm from './Components/Login/LoginForm';
import AdminDashboard from './Components/Dashboard/Admin/AdminDashboard';
import UserDashboard from './Components/Dashboard/User/UserDashboard';
import Warranty from './Components/Home/Warranty';
import Franchise from './Components/Home/Franchise';


const AppContent = ({ showLogin, setShowLogin }) => {
  const location = useLocation();
  const handleSignupSuccess = () => {
    setShowLogin(true);
  };

  // Check if the current route is a dashboard route
  const isDashboardRoute = location.pathname.startsWith('/admin-dashboard') || location.pathname.startsWith('/user-dashboard');

  // Get user role from localStorage
  const getUserRole = () => {
    try {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      return userData.role || null;
    } catch (error) {
      console.error('Error parsing userData:', error);
      return null;
    }
  };

  return (
    <>
      {!isDashboardRoute && <TopNavbar />}
      {!isDashboardRoute && <SecondNav />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/franchise" element={<Franchise />} />
        <Route path="/warranty" element={<Warranty />} />
        <Route path="/signup" element={<LoginForm onSignupSuccess={handleSignupSuccess} />} />
        <Route path="/login" element={<LoginForm />} />
        <Route
          path="/dashboard/*"
          element={
            getUserRole() === 'admin' ? (
              <Navigate to="/admin-dashboard" replace />
            ) : getUserRole() === 'user' ? (
              <Navigate to="/user-dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route path="/admin-dashboard/*" element={<AdminDashboard />} />
        <Route path="/user-dashboard/*" element={<UserDashboard />} />
        <Route path="*" element={<Navigate to={showLogin ? "/login" : "/signup"} replace />} />
      </Routes>
    </>
  );
};

const App = () => {
  const [showLogin, setShowLogin] = useState(false);

  return (
    <Router>
      <AppContent showLogin={showLogin} setShowLogin={setShowLogin} />
    </Router>
  );
};

export default App;